export default __webpack_public_path__ + "static/media/3DShape_09.f222fc79.png";